import {z} from 'zod';

/**
 * The model family stays custom as it is - the make remap sends it as a null target, the models
 * remap does not send it at all.
 */
export const KEEP_ORIGINAL_MODEL_FAMILY = '__KEEP_ORIGINAL__';

/**
 * Seeded from the usage rows of the replaced make - the backend requires an entry per model
 * family, though the target may be the keep-original sentinel.
 */
const modelFamilyMappingSchema = z.array(
  z.object({
    modelFamily: z.string(),
    targetModelFamily: z.string().min(1),
  })
);

export const remapMakeFormSchema = z.object({
  targetMake: z.string().min(1),
  modelFamilyMapping: modelFamilyMappingSchema,
});

export type RemapMakeFormValues = z.infer<typeof remapMakeFormSchema>;

// Keeping every model sends no request, so such a submit must not pass even without the button.
export const remapModelsFormSchema = z
  .object({modelFamilyMapping: modelFamilyMappingSchema})
  .refine((values) =>
    values.modelFamilyMapping.some((item) => item.targetModelFamily !== KEEP_ORIGINAL_MODEL_FAMILY)
  );

export type RemapModelsFormValues = z.infer<typeof remapModelsFormSchema>;
